/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_AnalyticsInputs */

const da_privacy_data_analytics = /** @type {(inputs: Privacy_Data_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Brugsstatistik og fejl:** hvilke funktioner du bruger (fx at du har oprettet en prøve eller startet en rettelse) og tekniske fejl i appen, knyttet til din konto med dit navn og din e-mailadresse. Det sker kun, hvis du har accepteret statistik i cookiebanneret. Det indeholder aldrig elevernes besvarelser, navne eller aliasser. Vi optager ikke skærmen.`)
};

/** @type {(inputs: Privacy_Data_AnalyticsInputs) => LocalizedString} */
const en_privacy_data_analytics = da_privacy_data_analytics;

/**

* @param {Privacy_Data_AnalyticsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_analytics = /** @type {((inputs?: Privacy_Data_AnalyticsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_AnalyticsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_analytics(inputs)
	return /** @type {LocalizedString} */ ("**Brugsstatistik og fejl:** hvilke funktioner du bruger (fx at du har oprettet en prøve eller startet en rettelse) og tekniske fejl i appen, knyttet til din konto med dit navn og din e-mailadresse. Det sker kun, hvis du har accepteret statistik i cookiebanneret. Det indeholder aldrig elevernes besvarelser, navne eller aliasser. Vi optager ikke skærmen.")
});